import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import AdminUploadPageUploadsListHeader from './UploadsListHeader';
import AdminUploadPageUploadsListItem from './UploadsListItem';

const AdminUploadPageUploadsList = ({
  uploads,
  ...props
}) => (
  <div className="table-wrapper">
    <Table className="users-list upload-pages-list upload-page-uploads-list" responsive>
      <thead>
        <AdminUploadPageUploadsListHeader
          {...props}
        />
      </thead>
      <tbody>
        {uploads.map(upload => (
          <AdminUploadPageUploadsListItem
            key={upload.uuid}
            upload={upload}
          />
        ))}
      </tbody>
    </Table>
  </div>
);

AdminUploadPageUploadsList.propTypes = {
  uploads: PropTypes.array.isRequired,
};

export default AdminUploadPageUploadsList;
